import React, {useState} from 'react';
import {Button, FloatingLabel, Form, Stack} from "react-bootstrap";
import {useNavigate} from 'react-router-dom'
import axios from "axios";

const Login = (props: any) => {
    const navigate = useNavigate()
    const [credentials, setCredentials] = useState<any>({
        login: null,
        password: null
    })
    const [error, setError] = useState<boolean>(false)
    async function handleLoginClick() {
        let answer = await axios.post('http://kitap.alsu.tatar/api/user/login', {...credentials})
        console.log('answer', answer.data)

        if (!answer.data) {
            setError(true)
            return
        }
        localStorage.setItem('@logged', JSON.stringify({time: new Date().getTime()}))
        navigate('/admin/catalog')
    }
    return (
        <Stack style={{width: '100%', minHeight: '100vh', alignItems: 'center', justifyContent: 'center'}}>
            <FloatingLabel label={'Логин'} className={'mb-3'}>
                <Form.Control style={error ? {borderColor: '#ff0000', borderWidth: 2} : {}} type="text" onChange={(e)=>setCredentials({...credentials, login: e.target.value})}></Form.Control>
            </FloatingLabel>
            <FloatingLabel label={'Пароль'} className={'mb-3'}>
                <Form.Control style={error ? {borderColor: '#ff0000', borderWidth: 2} : {}} type="password" onChange={(e)=>setCredentials({...credentials, password: e.target.value})}></Form.Control>
            </FloatingLabel>
            <Button onClick={handleLoginClick}>Вход</Button>
        </Stack>
    )
};

export default Login;
